import {observer} from 'mobx-react';
import {Table} from 'main/components';
import _ from 'lodash';
import CompletedIcon from 'img/list-element-complete@2x.png';
import IncompleteIcon from 'img/list-element-incomplete-default@2x.png';

const COLUMNS = [
  {
    header: 'nmbr.updates.directory.Form Name',
    width: 6,
    attribute: 'formName'
  },
  {
    header: 'nmbr.updates.directory.Total Claim Amount',
    width: 2,
    attribute: 'value'
  },
  {
    header: 'nmbr.updates.directory.Income Less Than Claim Amount',
    width: 2,
    render: model => <Checkmark checked={model.incomeLessThanClaimAmount}/>,
  },
  {
    header: 'nmbr.updates.directory.Additional Tax to be Deducted',
    width: 2,
    attribute: 'additionalTax'
  }
];

const Checkmark = observer(({checked}) => {
  return (
    <div className='flex justify-content-center'>
      <img src={checked ? CompletedIcon : IncompleteIcon} width='18' alt='complete'/>
    </div>
  );
});

const TaxFormCompleted = observer(({nmbrUpdate}) => {
  return (
    <Table
      columns={COLUMNS}
      models={_.filter(nmbrUpdate.fieldUpdates, {type: 'tax_form'})}
      showLinks={false}
    />
  );
});

export default TaxFormCompleted;
